import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { AuthenticationService } from '../services/authentication.service';
import { StorageService} from '../services/storage.service';
import { Storage } from '@ionic/storage';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService} from '../services/toast.service'
import { LoaderService } from '../services/loader.service';
import { ConnectionService } from '../services/connection.service';
import { DatePipe } from '@angular/common';
import { ReCaptchaV3Service } from 'ngx-captcha';
@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit {

  loginForm: FormGroup;
  ForgetPasswordForm: FormGroup;
  credentials: any;
  passwordtoogleicon: any = 'eye';
  correctpassword:boolean = false;
  showpassword: boolean = false;
  returnUrl: String;
  loader: boolean = false;

  userObj: any;
  mobileNo: string = "";
  otpNo: string = "";
  dob: any;
  gender: any;

  showMobileInupt: boolean = false;
  showOtpInupt: boolean = false;
  showDobInupt: boolean = false;
  showGenderInupt: boolean = false;

  constructor(private fb: FormBuilder,
    private storage: Storage,
    private authService: AuthenticationService,
    private strg: StorageService,
    private toast: ToastService,
    private router: Router,
    private route: ActivatedRoute,
    private _loader: LoaderService,
    private _datePipe: DatePipe,
    private apiService: ConnectionService,
    private recaptchaV3Service: ReCaptchaV3Service) {
      this._loader.hideLoader();
      this.authService.authState.subscribe(res => { 
        if(res === true){
          // this.router.navigate(['/home/dashboard']);
          this.checkBasicUserDetails();
        }else{
          this.showMobileInupt = false;
          this.showOtpInupt = false;
          this.showDobInupt = false;
          this.showGenderInupt = false; 
          this.correctpassword = false;
        }
      });
    }

  public errorMessages = {
    email: [
      { type: 'required', message: 'Email is required' },
      { type: 'pattern', message: 'Please enter a valid email address' }
    ],
    password: [
      { type: 'required', message: 'password is required' },
      { type: 'pattern', message: 'Please enter a valid password' }
    ]
  };
  
  get email() {
    return this.loginForm.get('email');
  }
  get password() {
    return this.loginForm.get('Password');
  }

  ngOnInit() {
    this._loader.hideLoader();
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9_+&*-]+(?:\\.+[a-zA-Z0-9_+&*-]+)*@+(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,4}$')]],
      Password: ['', Validators.required]
    });
    this.ForgetPasswordForm = this.fb.group({
      forgot_email: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9_+&*-]+(?:\\.+[a-zA-Z0-9_+&*-]+)*@+(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,4}$')]]
    });
  }

  togglepassword() {
    this.showpassword = !this.showpassword;
    // if (this.passwordtoogleicon == 'eye') {
    //   this.passwordtoogleicon = "eye-off";
    // }
    // else {
    //   this.passwordtoogleicon = "eye";
    // }
  }

  ForgotPassword(){
    this.correctpassword = true;
  }
  restPassword() {
    this.recaptchaV3Service.execute("6LcCPnckAAAAADZJkE0MecTtIFQup2y_4pa67Gpv", 'resetPwd', (token) => {
      this.apiService.checkRecaptchaResponse(String(token)).subscribe(res => {
        if (res) {
          let dataa = JSON.parse(res.data);
          if (dataa.success && dataa.score > 0.5 && dataa.action === "resetPwd") {
            let email = this.ForgetPasswordForm.get('forgot_email').value;
            this._loader.showLoader("Please Wait...");    
            this.loader = true;
            this.apiService.forgotpassword(email).subscribe(res => {
              this.loader = false;
              this._loader.hideLoader();
              console.log(res, "response of forget password");
              if (res.status = "200") {
                this.correctpassword = false;
                this.toast.showToast('Mail Sent To Registered Email Id Thank You !');
                this.router.navigateByUrl('/login');
              } else {
                console.log(res.data);
              }
            }, err => {
              this.loader = false;
              this._loader.hideLoader();
              console.log('mwj password error error', JSON.stringify(err));
              this.toast.showToast(err.error.error_description);
            });   
          }
        }
      }, err => { });
    });
  }

  backToLoginPage(){
    this.correctpassword = false;
  }

  submitFormOnEnter(event, formName){
    if(event.keyCode === 13 && !this.loginForm.invalid && formName === "login"){
      this.submitLoginForm();
    }
    if(event.keyCode === 13 && !this.ForgetPasswordForm.invalid && formName === "frpwd"){
      this.restPassword();
    }
  }

  submitLoginForm(){    
    this.recaptchaV3Service.execute("6LcCPnckAAAAADZJkE0MecTtIFQup2y_4pa67Gpv", 'login', (token) => {
      this.apiService.checkRecaptchaResponse(String(token)).subscribe(res => {
        if (res) {
          let dataa = JSON.parse(res.data);
          if (dataa.success && dataa.score > 0.5 && dataa.action === "login") {
            this.credentials = {
              email: this.loginForm.get('email').value,
              pwd: this.loginForm.get('Password').value
            } 
            this._loader.showLoader("Please Wait...");
            this.loader = true;
            this.authService.getInsAccessToken(this.credentials).subscribe(res => {
              this._loader.hideLoader();
              this.loader = false;
              if (res.access_token) {
                this.storage.ready().then(() => {
                  this.storage.set('insAccessToken', res.access_token).then(()=>{
                    this.storage.set('insRefreshToken', res.refresh_token).then(() => {
                      this.authService.authState.next(true);
                      this.toast.showToast('Login Successful!');  
                        // this.router.navigate(['/quote-upgrade']);
                        // this.authService.getUserDetails(this.credentials.email).subscribe(res => { //for direct ref
                        this.authService.getUserDetails().subscribe(res => {
                          if(res.status === "OK"){
                            this.strg.setStoreData("userObj",res.data).then(resss => {
                              console.log("save userobj", res.data);
                              setTimeout(()=>{
                                this.checkBasicUserDetails();
                              },1000)
                            });
                          }
                        })
                        // this.router.navigateByUrl(String(this.returnUrl), { replaceUrl: true });
                    });
                  });
                });
              }
            }, err => {
              this._loader.hideLoader();
              this.loader = false;
              console.log('insurance login error', JSON.stringify(err));
              console.log('insurance login error', err.error.error_description);
              this.toast.showToast(err.error.error_description);
            });
          }
        }
      }, err => { });
    });
  }

  checkBasicUserDetails(){
    this.strg.getStoreData("userObj").then(res => {
      this.userObj = res;
      console.log("userobj", res);
      if (res.setupStatus == 'SIGNUP_COMPLETED' || res.phoneNumber === "" || res.phoneNumber === null || res.phoneNumber === undefined) {
        this.showMobileInupt = true;
        this.showOtpInupt = false;
        this.showDobInupt = false;
        this.showGenderInupt = false;

      } else if (res.setupStatus == 'MOBILE_VARIFIED' || res.dob === "" || res.dob === null || res.dob === undefined) {
        this.showDobInupt = true;
        this.showMobileInupt = false;
        this.showOtpInupt = false;
        this.showGenderInupt = false;
      } else if (res.setupStatus == 'DOB_UPDATED' || res.gender === "" || res.gender === null || res.gender === undefined) {
        this.showGenderInupt = true;
        this.showMobileInupt = false;
        this.showOtpInupt = false;
        this.showDobInupt = false;
      } else if (res.setupStatus == 'GENDER_UPDATED' || res.gender != "" || res.setupStatus == 'TC_ACCEPTED' || res.setupStatus == 'LOI_ACCEPTED') {
        this._loader.hideLoader();
        this.router.navigateByUrl(String(this.returnUrl), { replaceUrl: true });
      }
    });
  }

  sendOtp(){
    console.log("mobileNo", this.mobileNo);
    this._loader.showLoader();
    // this.apiService.sendOtp(this.mobileNo,this.userObj.id).subscribe(res => { //for direct ref
    this.apiService.sendOtp(this.mobileNo).subscribe(res => {
      this._loader.hideLoader();
      console.log("opt res", res);
      if (res.data.type === "success") {
        this.toast.showToast("OTP Sent Successfully");
        this.showOtpInupt = true;
      }
    }, err => {
      this._loader.hideLoader();
      this.toast.showToast(err.error.message);
      console.log("otp error", err)
    })

  }

  resendOtp(){
    this._loader.showLoader();
    // this.apiService.resendOtp(this.mobileNo,this.userObj.id).subscribe(res => { //for direct ref
    this.apiService.resendOtp(this.mobileNo).subscribe(res => {
      this._loader.hideLoader();
      console.log("resedn opt res", res);
      if (res.data.type === "success") {
        this.toast.showToast("OTP Sent Successfully");
      }else{
        this.toast.showToast(res.data.message)
      }
    }, err => {
      this._loader.hideLoader();
      if (err.message) {
        this.toast.showToast(err.message);
      }else {
        this.toast.showToast(err.error.message);
      }
      console.log("resend otp error", err)
    })
  }

  verifyOtp(){
    if (this.otpNo && this.mobileNo) {
      let data = {
        'mobile': this.mobileNo,
        'otp': this.otpNo,
        // 'userId': this.userObj.id //for direct ref
      };
      this._loader.showLoader();
      this.apiService.verifyOtp(data).subscribe(res => {
        this._loader.hideLoader();
        console.log("verify otp res",res);
        if (res.data.type === "success") {
          this.toast.showToast("OTP Verified Successfully");
          let userData = {
            // "email" : this.userObj.email, //for direct ref
            "status" : "MOBILE",
            "value" : this.mobileNo
          }
          console.log("opt success user data to save", userData);
          this.saveUserData(userData);
        }else{
          this.toast.showToast("Invalid OTP");
        }
      }, err => {
        this._loader.hideLoader();
        this.toast.showToast(err.error.message);
        console.log("verify otp error", err);
      })
    }
  }

  // editMobNo(){
  //   this.showOtpInupt = false;
  //   // this.showMobileInupt = true;
  // }

  submitDOB(){
    let dob = this._datePipe.transform(this.dob, 'dd/MM/yyyy');
    let userData = {
      // "email": this.userObj.email, //for direct ref
      "status": "DOB",
      "value": dob
    }
    this.saveUserData(userData);
  }

  submitGender(){
    let userData = {
      // "email": this.userObj.email, //for direct ref
      "status": "GENDER",
      "value": this.gender
    }
    this.saveUserData(userData);
  }

  saveUserData(data){
    this.apiService.saveBasicUserDetails(data).subscribe(res => {
      console.log("save user data res", res);
      this.getUserDetailsHere();
    }, err => {
      console.log("save user data error", err);
    });
  }


  getUserDetailsHere(){
    // this.authService.getUserDetails(this.userObj.email).subscribe(res => { //for direct ref
    this.authService.getUserDetails().subscribe(res => {
      console.log("get user details", res);
      if(res.status === "OK"){
        this.strg.setStoreData("userObj",res.data).then(res => {
          this.checkBasicUserDetails();
        });
      }
    }, err => {
      console.log("get userdetails error",)
    })
  }

  //only letter validation
  validateLettersOnly(event) {
    console.log("target", event);
    if (!/^[a-zA-Z ]*$/g.test(event.key)) {
      return false;
    } else {
      return true;
    }
  }

  // NUMERICS only validation
  validateNumericsOnly(event) {
    var key = window.event ? event.keyCode : event.which;
    if (event.keyCode == 8 || event.keyCode == 39 || event.keyCode == 9) {
      return true;
    }
    else if (key < 48 || key > 57) {
      return false;
    }
    else return true;
  }

}
